<template>
    <app-button icon="menu" :title="$t('menu')" class="align-self-center" @click="toggleMenu" />
</template>

<script>
export default {
    name: 'AppMenuButton',
    methods: {
        toggleMenu() {
            this.$store.dispatch('system/toggleMenuPanel');
        }
    }
};
</script>
